import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import {
  Button,
  Dropdown,
  DropdownTrigger
} from '@salesforce/design-system-react';

import './HeaderDropdown.scss';

class HeaderDropdown extends Component {
  label() {
    return this.selection()?.[0]?.label;
  }

  selection() {
    const item = this.props.options.find(opt => opt.value === this.props.value);
    return item ? [item] : [];
  }

  render() {
    return (
      <div className="header-dropdown">
        <Dropdown
          iconCategory="utility"
          iconName="down"
          onSelect={this.props.onSelect}
          options={this.props.options}
          value={this.props.value}
          size="x-small"
        >
          <DropdownTrigger>
            <Button iconCategory="utility" iconName="down" iconPosition="right">
              <h1>{this.label()}</h1>
            </Button>
          </DropdownTrigger>
        </Dropdown>
      </div>
    );
  }
}

HeaderDropdown.propTypes = {
  options: PropTypes.array,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object
  ]),
  onSelect: PropTypes.func.isRequired,
  location: PropTypes.object
};

export default injectIntl(HeaderDropdown);
